import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Customer Data Maturity: How&nbsp;the World’s Biggest Companies Win by Unlocking Customer Potential`,
  subheading: `by Twilio Segment`,
  description: `Welcome to the resources hub for our comprehensive guide to Customer Data Maturity. If you made it to this page, presumably your goal is to develop data strategies that actively unlock business opportunities. The path to data maturity first and foremost requires adopting a customer data platform (CDP) such as Twilio Segment to gain a complete understanding of your customer. Your CDP serves as the essential foundation of the modern data stack by integrating and organizing data from every data source, platform, and channel to create a unified customer file.`,
  caption: `To help guide you through your book, we’ve collected a series of resources to aid you on your customer data journey:`,
}

const Hero = () => {
  const theme = useTheme()

  return (
    <Wrapper>
      <HeroComponent variant="article">
        <HeroRecipe.Contents>
          <Typography variant="h1" tag="h1" dangerouslySetInnerHTML={{ __html: copy.heading }} />
          <Subheading variant="pLarge" tokens={{ color: theme.palette.twilio.gray[80] }}>
            <em>{copy.subheading}</em>
          </Subheading>
          <Typography variant="pLarge" tokens={{ color: theme.palette.twilio.gray[80] }}>
            {copy.description}
          </Typography>
          <Typography variant="pLarge" tokens={{ color: theme.palette.twilio.gray[80] }}>
            {copy.caption}
          </Typography>
        </HeroRecipe.Contents>
      </HeroComponent>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroComponent = styled(HeroBase)`
  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding-left: 218px;
  }

  ${HeroRecipe.Wrapper} {
    gap: 0;

    ${HeroRecipe.Contents} {
      justify-items: start;
    }
  }
`

const Subheading = styled(Typography)`
  margin-top: 0;
`

export default Hero
